import { lineFont } from '../../state/font';

interface GridIconButtonLabelLayout {
  font: string;
  x: number;
  y: number;
}

const MIN_LABEL_FONT_SIZE = 9;
const MAX_LABEL_FONT_SIZE = 12;
const LABEL_FONT_HEIGHT_RATIO = 0.3;
const LABEL_BASELINE_Y_RATIO = 0.88;

const roundToTenth = (value: number): number => Math.round(value * 10) / 10;

export const getGridIconButtonLabelLayout = (
  width: number,
  height: number
): GridIconButtonLabelLayout => {
  const fontSize = roundToTenth(
    Math.min(
      MAX_LABEL_FONT_SIZE,
      Math.max(MIN_LABEL_FONT_SIZE, height * LABEL_FONT_HEIGHT_RATIO)
    )
  );

  return {
    font: `bold ${fontSize}px ${lineFont}`,
    x: width / 2,
    y: roundToTenth(height * LABEL_BASELINE_Y_RATIO),
  };
};

export const paintGridIconButtonLabel = (
  ctx: CanvasRenderingContext2D,
  label: string,
  width: number,
  height: number,
  color: string
): void => {
  const layout = getGridIconButtonLabelLayout(width, height);

  ctx.fillStyle = color;
  ctx.font = layout.font;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'bottom';
  ctx.fillText(label, layout.x, layout.y);
};
